import React from "react";
import "./card.css";
import TagLabel from "../tagLabel/taglabel";
import Button from "../button/button";
import classNames from "classnames";
import IconCredit from "../icon/iconCredits";
import { useTranslation } from 'react-i18next';

const Card = ({
  id,
  category,
  isNew,
  tagLabel,
  imgSrc,
  description,
  onClick,
  btnLabel,
  useCaseName,
  children,
  disabled,
  customClassName = "",
  hasIconCredit,
  hasIcon,
  creditN,
  animating,
  translations
}) => {
  const { t, i18n } = useTranslation();
  const className = "card";
  const currentTranslation = translations?.find(e => e.locale.code === i18n.language)
  return (
    <div
      id={id}
      className={classNames(className, customClassName)}
      data-category={t("create")}
      onClick={btnLabel ? null : onClick}
    >
      {currentTranslation?.description && (
        <div className="card-content">
          {imgSrc && <img className="card-content_img" src={imgSrc} alt="" />}
          <div className="flex flex-col gap-2">
            <div className="flex flex-row gap-2 items-center">
              {isNew && <TagLabel label={tagLabel ? t("home_etiqueta_nuevo") : ''} isNew={isNew} />}
              <span className="uppercase text-2.5 leading-2.5 text-Grey-600 font-black antialiased">
                {currentTranslation?.tag}
              </span>
            </div>
            <p
              className="card-content_text"
              dangerouslySetInnerHTML={{ __html: currentTranslation.description }}
            />
          </div>
          <div className="flex flex-col justify-between h-full relative">
            {hasIconCredit && <IconCredit creditNumber={creditN} />}
            {hasIconCredit && animating && (
              <div className="number-float">{creditN}</div>
            )}
          </div>
        </div>
      )}
      {children && <div className="card-children">{children}</div>}
      {btnLabel && (
        <div className="card-CTA">
          <Button
            label={btnLabel}
            variant="primary"
            onClick={onClick}
            disabled={disabled}
            hasIcon={hasIcon}
          />
        </div>
      )}
    </div>
  );
};

export default Card;
